(function () {
  let prefix;
  let lang = document.documentElement.lang || 'en';
  lang = lang.substring(0,2);
  if (lang === "en") {
    prefix = "Open in new window";
  } else if (lang === "de") {
    prefix  = "Im neuen Fenster";
  }

  let refs = document.querySelectorAll("a[href]");
  if (refs.length > 0) {
    let host = window.location.host;
    for (let i = 0; i < refs.length; i++) {
      let href = refs[i].getAttribute('href');
      let hit = /https?:\/\/(www\.)?([^\/]*)/i.exec(href);
      if (hit && hit[2]) {
        if (host != hit[1]+hit[2]) {
          refs[i].classList.add('external');
          let title = refs[i].getAttribute('title');
          if (title) {
            title = prefix + ' - ' + title;
          } else {
            title = prefix;
          }
          refs[i].setAttribute('title', title);
          let target = refs[i].getAttribute('target');
          if (!target) {
            refs[i].setAttribute('target', '_blank');
          }
        }
      }
    }
  }

})();
